import { action, observable, toJS, runInAction } from 'mobx'
import Api from '@api/hotel/menu'
import { serviceTypes } from './constants'
import API from '@api/hotel/niuniu'
import { getMerchantInfo } from '@util'
import { message, Modal } from 'hljd'
import MenuStore from './CreateForm/Menus/store'
import { hashHistory } from 'react-router'
import { PATH_HOTEL_MENU_MANAGE } from '../constant'

export default class Store {
  constructor(id) {
    this.id = id
    this.menuStore = new MenuStore()
    this.init()
  }
  @observable business_status = false
  // 表单字段
  @observable menuName = ''
  @observable tablePrice = ''
  @observable tablePriceErr = false
  @observable servePrice = ''
  @observable serveType = '' // 菜单服务费类型
  @observable servePercent = '' // 菜单服务费加收/按百分比
  @observable serveFee = '' // 菜单服务费加收/固定金额
  @observable addition = ''
  @observable menuPics = [] //菜品图片
  @observable template_id = '' // 模板id
  @observable cover_path = '' //
  @observable getMenuLoading = false
  @observable saveMenuLoading = false
  @observable recommend_food = '' // 推荐菜

  init = async () => {
    const info = getMerchantInfo()
    this.business_status = info.business_status
    if (this.id) {
      await this.getMenu()
    }
    //this.getTemplate()
  }

  // getTemplate = async () => {
  //   const { data, success } = await Api.getMenuTemplate()
  //   if (success) {
  //     this.templates = data
  //     if (!this.template_id) {
  //       this.template_id = this.templates[0] && this.templates[0].id
  //     }
  //   }
  // }

  getMenu = async () => {
    this.getMenuLoading = true
    const { data } = await Api.getMenu({ id: this.id })
    if (!data) {
      return
    }
    runInAction(() => {
      this.getMenuLoading = false
      const {
        name,
        price,
        service_fee_option,
        addition,
        series,
        service_fee,
        cover_path,
        menu_pics,
        recommend_food
      } = data

      this.menuName = name
      this.tablePrice = price
      this.addition = addition
      this.menuStore.menus = series
      this.cover_path = cover_path
      this.serveType = service_fee_option ? +service_fee_option.type : 3
      this.recommend_food = recommend_food
      this.business_status &&
        (this.menuPics =
          typeof menu_pics === 'string'
            ? JSON.parse(menu_pics)?.map(item => ({
                url: item.cover_path,
                type: 'image',
                width: item.width,
                height: item.height
              }))
            : menu_pics?.map(item => ({
                url: item.cover_path,
                type: 'image',
                width: item.width,
                height: item.height
              })))
      //根据serveType判断value赋给字段
      if (service_fee_option) {
        switch (this.serveType) {
          case serviceTypes.PERSONALLY:
          case serviceTypes.NONE:
            break
          case serviceTypes.FIXED_PERCENT:
            this.servePercent = (service_fee_option.value * 100).toFixed(1)
            break
          case serviceTypes.FIXED_AMOUNT:
            this.serveFee = service_fee_option.value
        }
      } else {
        this.serveFee = service_fee
      }
    })
  }

  setFromValue = type => v => {
    v = v.target ? v.target.value : v
    v = v || ''

    // 校验数字
    if (/Price/.test(type) || /serveFee/.test(type)) {
      let handleV = v.replace(/[^0-9]+/, '')
      this[type] = handleV
      return
    }

    // 校验一位小数
    if (/servePercent/.test(type)) {
      let handleV = v.replace(/([0-9]+\.[0-9]{1})[0-9]*/, '$1')
      this[type] = handleV
      return
    }

    this[type] = v
  }

  validate = () => {
    if (!this.tablePrice) {
      return '请填写单桌价位'
    }
    if (this.serveType === serviceTypes.FIXED_PERCENT) {
      let pass = /^[0-9]+([.]{1}[0-9])?$/.test(this.serveData)
      if (!pass) {
        return '请输入正确的加收比例'
      }
    }
    if (this.serveType === serviceTypes.FIXED_AMOUNT && !this.serveFee) {
      return '请输入菜单服务费加收金额'
    }
  }

  // 校验文案配置
  REQUIRED_LIST = [
    { name: 'menuName', message: '菜单名称必须填' },
    { name: 'tablePrice', message: '单桌价位必须填' },
    { name: 'serveType', message: '菜单服务费必选' },
    { name: 'recommend_food', message: '请输入推荐菜' }
  ]

  submit = async () => {
    /**
     * 必填校验
     */
    for (let i = 0; i < this.REQUIRED_LIST.length; i++) {
      const item = this.REQUIRED_LIST[i]
      if (!this[item.name]) {
        return message.error([item.message])
      }
    }

    let service_fee_option = { type: this.serveType }
    switch (this.serveType) {
      case serviceTypes.PERSONALLY:
      case serviceTypes.NONE:
        break
      case serviceTypes.FIXED_PERCENT:
        if (!this.servePercent) {
          return message.error('请填写服务费固定比例')
        }
        service_fee_option.value = this.servePercent
        break
      case serviceTypes.FIXED_AMOUNT:
        if (!this.serveFee) {
          return message.error('请填写服务费固定金额')
        }
        service_fee_option.value = this.serveFee
        break
    }

    if (this.menuStore.menus.some(item => !item.food_name.length)) {
      return message.error('菜单请添加至少一个菜品')
    }
    if (
      this.business_status &&
      (this.menuPics?.length < 3 || this.menuPics?.length > 10)
    ) {
      return message.error('请上传3-10张真实的菜品图片')
    }
    // if (this.menuStore.menus.some(item => !item.cover_path.length)) {
    //   return message.error('菜单至少添加一张菜品图片')
    // }

    let param = {
      name: this.menuName,
      price: this.tablePrice,
      service_fee_option,
      addition: this.addition || '',
      series: toJS(this.menuStore.menus),
      cover_path: this.cover_path,
      recommend_food: this.recommend_food
    }
    this.business_status &&
      (param = Object.assign(param, {
        menu_pics: this.menuPics?.map(item => ({
          cover_path: item.url,
          width: item.width,
          height: item.height
        }))
      }))
    this.id && (param.id = this.id)
    this.saveMenuLoading = true
    const { data, success } = await Api.saveMenu(param)

    if (!data || !success) {
      this.saveMenuLoading = false
      return
    }
    // 编辑状态下，判断酒店菜单是否绑定了套餐
    if (success && this.id) {
      const hadConnected = await this.mealCheckByMenulId(this.id)
      if (hadConnected) {
        this.saveMenuLoading = false
        return Modal.info({
          title: '您将该菜单关联在套餐中，此修改会同步到此套餐',
          okText: '知道了',
          onOk: () => {
            hashHistory.push(`${PATH_HOTEL_MENU_MANAGE}?key=2`)
          }
        })
      }
    }
    hashHistory.push(`${PATH_HOTEL_MENU_MANAGE}?key=2`)
  }

  // 判断酒店菜单是否绑定了套餐
  @action
  mealCheckByMenulId = async id => {
    const { success, data = {} } = await API.mealCheckByMenulId({ id })
    if (success) {
      return data.mealId
    }
  }
}
